/**
 * experiments/tests/clickgen.js
 *
 * A central location to house all experiments related to clickgen. This file is currently
 * included in the combined_experiments.js package.
 */
;(function (win) {
  let Experiments = win.slideshare_object.utils.imports("Experiments"),
    experiments = new Experiments(),
    CLICKGEN_EXPERIMENT = "slideview-clickgen-cta",
    CLICKGEN_EXPERIMENT_2 = "slideview-clickgen-cta-2"

  // Delete already existing experiment
  experiments.deleteExperiment(CLICKGEN_EXPERIMENT)
  // Slideview Clickgen CTA placement experiment
  // b -> Top right corner next to clip button
  // 100% ramp
  experiments.register(CLICKGEN_EXPERIMENT_2, {
    b: 100,
  })
})(window)
